export { SettingsView } from "../../components/settings/settings-view";
